import React from 'react';
import { useTranslation } from 'react-i18next';
import { faAngleLeft, faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import thumb1 from '../../assets/video-thumbs/planning.png';
// import thumb2 from '../../assets/video-thumbs/workorder.png';
// import thumb3 from '../../assets/video-thumbs/mobile.png';
// import thumb4 from '../../assets/video-thumbs/projects-create.png';
// import thumb5 from '../../assets/video-thumbs/projects-planning.png';

const OnboardingVideos: React.FC<{ onBack?: () => void }> = ({ onBack }) => {
    const { t } = useTranslation();

    const handleOpenVideo = (url: string) => {
        console.log('Open video:', url);
    };

    const renderVideoCard = (
        number: number | null,
        title: string,
        description: string,
        url: string,
        thumbnail?: string
    ) => {
        return (
            <div 
                className="video-card"
                onClick={() => handleOpenVideo(url)}
            >
                <div className='details'>
                    {number !== null ? (
                        <div className="video-number">
                            {number}
                        </div>
                    ) : (
                        <div className="video-number-spacer" />
                    )}

                    <div className="video-content">
                        <h6>{t(title)}</h6>
                        <p>{t(description)}</p>
                    </div>
                </div>

                <div className="video-thumbnail">
                    <img src={thumbnail} alt={t(title)} />

                    <div className="play-icon">
                        <FontAwesomeIcon icon={faCirclePlay} />
                    </div>
                </div>
            </div>
        );
    };

    const quickStartVideos = [
        {
            number: 1,
            title: "dashboard.onboarding.intro_video_title",
            description: "dashboard.onboarding.intro_video_description",
            url: '',
            // thumbnail: thumb1
        },
        {
            number: 2,
            title: "dashboard.onboarding.first_job_video_title",
            description: "dashboard.onboarding.first_job_video_description",
            url: '',
            // thumbnail: thumb2
        },
        {
            number: 3,
            title: "dashboard.onboarding.mobile_app_video_title",
            description: "dashboard.onboarding.mobile_app_video_description",
            url: '',
            // thumbnail: thumb3
        },
        {
            number: 4,
            title: "dashboard.onboarding.finish_job_video_title",
            description: "dashboard.onboarding.finish_job_video_description",
            url: '',
            // thumbnail: thumb4
        },
        {
            number: 5,
            title: "dashboard.onboarding.proposal_video_title",
            description: "dashboard.onboarding.proposal_video_description",
            url: '',
            // thumbnail: thumb5
        }
    ];

    const additionalVideos = [
        {
            title: "dashboard.onboarding.scheduling_video_title",
            description: "dashboard.onboarding.scheduling_video_description",
            url: '',
            // thumbnail: thumb6
        },
    ];

    return (
        <div className="video-list">

            <div className="video-header">
                <div className='title'>
                    {onBack && (
                        <div 
                            className='back-button'
                            onClick={onBack}
                        >
                            <FontAwesomeIcon icon={faAngleLeft} />
                        </div>
                    )}
                    <h2>{t('dashboard.onboarding.header')}</h2>
                </div>
                <p>{t('dashboard.onboarding.header_explanation')}</p>
            </div>


            <div className="video-section">
                <h3>{t('dashboard.onboarding.quick_start_title')}</h3>

                <div className="video-cards">
                    {quickStartVideos.map((video) =>
                        renderVideoCard(
                            video.number,
                            video.title,
                            video.description,
                            video.url,
                            // video.thumbnail
                        )
                    )}
                </div>
            </div>

            <div className="video-separator" />

            <div className="video-section">
                <h3>{t('dashboard.onboarding.discover_more_title')}</h3>

                <div className="video-cards">
                    {additionalVideos.map((video) =>
                        renderVideoCard(
                            null,
                            video.title,
                            video.description,
                            video.url,
                            // video.thumbnail
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default OnboardingVideos;